/**
 * @generated SignedSource<<c15942b0744cc3d388e304914c0b0a41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useLabelsFragment_content$data = Result<{
  readonly id: string | null;
  readonly labels: {
    readonly count: number | null;
  } | null;
  readonly " $fragmentType": "useLabelsFragment_content";
}, unknown>;
export type useLabelsFragment_content$key = {
  readonly " $data"?: useLabelsFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useLabelsFragment_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useLabelsFragment_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASCENDING",
            "sortField": "LABELLING_CREATIONDATE"
          }
        }
      ],
      "concreteType": "PaginatedLabelList",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        }
      ],
      "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
    }
  ],
  "type": "Content"
};

(node as any).hash = "3eba8bac5df98dba7354779408092c88";

export default node;
